import React from 'react'
import Nestable from 'react-nestable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripLines } from '@fortawesome/pro-regular-svg-icons/faGripLines'
import styled from '@emotion/styled'

const SortableRow = styled.div`
    cursor: grab;
    background-color: #666;
    border-bottom: 1px solid;
    padding: 10px 15px;
    border-radius: 3px;

    &:last-child {
        border-bottom: none;
    }

    &:active {
        cursor: grabbing;
        background-color: #888;
    }
`

const ListItem = ({ item }) => (
    <SortableRow>
        <FontAwesomeIcon icon={faGripLines} className="mr-2" />{' '}
        {item.question ? item.question.replace(/<[^>]+>/g, '') : `FAQ Item ${item.id + 1}`}
    </SortableRow>
)

const FAQsItemSort = ({ faqs, onChange }) => {
    const faqItems = faqs.map((faq, idx) => ({ ...faq, id: idx }))
    return (
        <Nestable
            items={faqItems}
            renderItem={ListItem}
            onChange={items => onChange({ faqs: items })}
            maxDepth={1}
        />
    )
}

export default FAQsItemSort
